import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { isSubmitKeyDown } from '../../../../utils/events'
import { ConfirmationModal } from '../../../Confirmation'
import { QA_NAME_GRETA_AI_CHAT_RENAME_INPUT } from '../../GretaAIChat.constants'
import {
  getIsGretaAIChatNameFormValid,
  GretaAIChatNameField,
} from '../../GretaAIChatNameField'

function GretaAIChatRenameModalForm({
  hasCounter,
  maxLength,
  placeholder,
  qaName = QA_NAME_GRETA_AI_CHAT_RENAME_INPUT,
  title,
  validationSchema,
  onCancel,
}) {
  const { t } = useTranslation()

  const { isSubmitting, submitForm, values } = useFormikContext()

  const isSaveDisabled = !getIsGretaAIChatNameFormValid({
    validationSchema,
    values,
  })

  function handleKeyDown(event) {
    if (isSubmitKeyDown(event) && !isSaveDisabled && !isSubmitting) {
      submitForm()
    }
  }

  return (
    <ConfirmationModal
      Description={null}
      actionButtonsProps={{
        submitProps: { disabled: isSaveDisabled },
        submitText: t('Greta.SaveButtonKey'),
      }}
      loading={isSubmitting}
      title={title}
      onCancel={onCancel}
      onSubmit={submitForm}
    >
      <GretaAIChatNameField
        hasCounter={hasCounter}
        inputProps={{ onKeyDown: handleKeyDown }}
        maxLength={maxLength}
        placeholder={placeholder}
        qaName={qaName}
      />
    </ConfirmationModal>
  )
}

export default GretaAIChatRenameModalForm
